import { useMemo } from 'react';

import { ScreenReadersContent } from '@hivebrite/design-system/ScreenReadersContent';

import {
  POST,
  TOPIC_POST,
} from 'hb-react/frontoffice/apps/LiveFeed/constants/PostApiTypes';
import {
  HtmlContent,
  HtmlContentWithIframe,
} from 'hb-react/shared/components/HtmlContent';
import { Translation } from 'hb-react/shared/components/Translation';
import { truncateHtmlAt } from 'hb-react/shared/utils/truncateHtmlAt';

interface Props {
  type: string;
  id: string;
  content: string;
  user: any;
  a11yId: string;
  hasMore: boolean;
  showMore: boolean;
}

const MAX_CONTENT_LENGTH = 100;

const Content = ({
  type,
  id,
  content,
  user,
  a11yId,
  hasMore,
  showMore,
}: Props) => {
  // This text is used only for specific content types. For other types, the Translation will manage the truncation.
  const trimmedText = useMemo(() => {
    if (hasMore) {
      const { html } = truncateHtmlAt(content, MAX_CONTENT_LENGTH);

      return html;
    }

    return content;
  }, [content, hasMore]);

  const renderContent = () => (
    <>
      {hasMore && (
        <ScreenReadersContent id={a11yId}>
          <HtmlContent content={showMore ? content : trimmedText} />
        </ScreenReadersContent>
      )}
      <div aria-hidden={hasMore}>
        <HtmlContentWithIframe content={content} />
      </div>
    </>
  );

  if (![POST, TOPIC_POST].includes(type)) {
    return renderContent();
  }

  return (
    // @ts-expect-error incorrect type of children
    <Translation
      model={{ id, user, type }}
      attribute="content_html"
      screenReadersTruncate={{
        htmlId: a11yId,
        limit: MAX_CONTENT_LENGTH,
        isTruncated: showMore,
      }}
    >
      {renderContent()}
    </Translation>
  );
};

export default Content;
